export function loadUouChatMessages(locale) {
  return new Promise((resolve, reject) => {
    import(/* webpackChunkName: "[request]" */`../assets/locale/uou-chat/uou_chat_messages_${locale}.json`).then(module => {
      resolve(module.default);
    }).catch(reject);
  });
}
//# sourceMappingURL=loadUouChatMessages.js.map